// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/_foundation.js";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//Hamburger icon
let hamburger = $(".hamburger");
hamburger.on("click", function () {
  hamburger.toggleClass("is-active");
});

$(".off-canvas-wrapper").on("closed.zf.offcanvas", function () {
  hamburger.removeClass("is-active");
});

// window.onscroll = function() {myFunction()};
let navbar = document.getElementById("site-header");
let sticky = navbar.offsetTop; // Get the offset position of the navbar

window.addEventListener("scroll", () => {
  if (window.pageYOffset > sticky) {
    navbar.classList.add("sticky");
  } else {
    navbar.classList.remove("sticky");
  }
});

$(".related-links").on("change", function () {
  let target = $(this).find(":selected").attr("data-target");
  let url = $(this).val();
  if (url != "") {
    if (target == "_blank") {
      window.open(url, "_blank").focus();
    } else {
      window.location = url;
    }
  }
  return false;
});

/* $(".document-container").each(function (e) {
  let $this = $(this);
  let header = $this.find(".document-header");
  let body = $this.find(".document-body-outer");
  body.on("click", function () {
    body.slideToggle(300);
    if (header.hasClass("active-document")) {
      header.removeClass("active-document");
    } else {
      header.addClass("active-document");
    }
  });
}); */


$('body').on('click', '.document-header', function(){
  let header = $(this);
  let body = $(this).siblings('.document-body-outer');
  body.slideToggle(300);
    if (header.hasClass("active-document")) {
      header.removeClass("active-document");
    } else {
      header.addClass("active-document");
    }

});


/* $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
  $('#offcanvas-filter').foundation('close');
}); */

$("[data-open]").on("click", function (e) {
  e.preventDefault();
});

$(".tabs--specs .tabs-title a").on("click", function (e) {
  let headerHeight = $("#site-header").outerHeight() + 15;
  $("html, body").animate(
    {
      scrollTop: $(".tabs-content--specs").offset().top - headerHeight,
    },
    300
  );
});

$(".button--view-results").on("click", function () {
  let headerHeight = $("#site-header").outerHeight() + 200;
  $("html, body").animate(
    {
      scrollTop: $("#main").offset().top - headerHeight,
    },
    300
  );
});

$(".fireplace-hero__down").on("click", function () {
  let $this = $(this);
  let target = $this.closest(".fireplace-hero").next();
  let headerHeight = $("#site-header").outerHeight();
  $("html, body").animate(
    { scrollTop: target.offset().top - headerHeight },
    400
  );
});


$(".fireplace-hero__down").on("click", function () {
  let $this = $(this);
  let target = $this.closest(".fireplace-hero").next();
  let headerHeight = $("#site-header").outerHeight();
  $("html, body").animate(
    { scrollTop: target.offset().top - headerHeight },
    400
  );
});

/* Video mp4 responsive */
var videoModules = document.querySelectorAll(".video-modules");
//add source to video tag
function addSourceToVideo(element, src) {
  var source = document.createElement("source");
  source.src = src;
  // source.dataset.src = src;
  source.type = "video/mp4";
  element.appendChild(source);
}

//determine screen size and select mobile or desktop vid
function whichSizeVideo(element, src) {
  var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
  if (windowWidth >= 1024) {
    addSourceToVideo(element, src.dataset.vidsrcd);
  }else if(windowWidth >= 640 && windowWidth < 1024){
    addSourceToVideo(element, src.dataset.vidsrct ? src.dataset.vidsrct : src.dataset.vidsrcd);
  } else {
    addSourceToVideo(element, src.dataset.vidsrcm);
  }
}

//init only if page has videos
function videoSize() {
  if (videoModules !== undefined) {
    videoModules.forEach(function (element, index) {
      whichSizeVideo(
        element, //element
        element //src locations
      );
    });
  }
}
videoSize();

/* 

document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.newlazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
}); */


// WEBPACK FOOTER //
// ./scripts/main.js